import { PrintType } from './types';
import { frame } from '@/providers/CartProvider';

export interface BasicFrameProperties {
    frameStatus: FrameStatus;
    priceDifference: number;
    availableColors: FrameColor[];
}
export interface FramedFrameProperties extends BasicFrameProperties {
    frameStatus: FrameStatus.FRAMED;
    unframedVersion: PrintType;
}
export interface UnframedFrameProperties extends BasicFrameProperties {
    frameStatus: FrameStatus.UNFRAMED;
    framedVersion: PrintType;
}
export interface Print {
    type: PrintType;
    printProperties?: {
        frameColor: FrameColor;
    };
    frameProperties?: FramedFrameProperties | UnframedFrameProperties;
    delivery: PrintDelivery;
}
export enum FrameColor {
    WHITE = 'WHITE',
    BLACK = 'BLACK',
    WOOD = 'WOOD'
}
export enum FrameStatus {
    FRAMED = "FRAMED",
    UNFRAMED = "UNFRAMED"
}
export enum PrintDelivery {
    DIGITAL = 'DIGITAL',
    PHYSICAL = 'PHYSICAL',
    BOTH = 'BOTH'
}
export interface FramedPrint extends Print {
    type: PrintType.posterFramed;
    printProperties: {
        frameColor: FrameColor;
    };
}
export function isPrintType(printType: any): printType is PrintType {
    return Object.values(PrintType).includes(printType);
}
export function isFrameColor(frameColor: any): frameColor is FrameColor {
    return Object.values(FrameColor).includes(frameColor);
}
export function requiresShipping(delivery: PrintDelivery): boolean {
    return delivery != PrintDelivery.DIGITAL;
}

export function isFrameable(frameProperties:BasicFrameProperties): frameProperties is UnframedFrameProperties {
    if (frameProperties == undefined) return false
    return frameProperties.frameStatus == FrameStatus.UNFRAMED
}
export function isFramed(frameProperties:BasicFrameProperties): frameProperties is FramedFrameProperties {
    if (frameProperties == undefined) return false
    return frameProperties.frameStatus == FrameStatus.FRAMED
}